(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('StatusAlumnoPlanDeEstudios', StatusAlumnoPlanDeEstudios);

    StatusAlumnoPlanDeEstudios.$inject = ['$resource'];

    function StatusAlumnoPlanDeEstudios ($resource) {
        var resourceUrl =  'api/status-alumno-plan-de-estudios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
